import { GraphqQlApi } from '@/api/api.js'
import DataSourceBase from '../DataSourceBase'

export default class PaymentsDataSource extends DataSourceBase {
  constructor(Vue, id) {
    super(Vue, id)
  }

  callAction(actionName) {
    if (actionName == 'pay') {

      this.$store.commit('SET_PROCESSING', true)

      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

      var urlencoded = new URLSearchParams()
      urlencoded.append('calcId', 'SMS.LEAD.NEWINVOICE')
      var data = {
        'parameters':
        {
          'orgId': 104873, 'orgCode': '22981300', 'orgName': 'АТ "УКРПОШТА" СУМСЬКА ДИРЕКЦІЯ',
          'email': 'demo@it.ua', 'service': 'KOEE_BOX', 'provider': '_PLATON', 'price': 152.55
        }
      }
      urlencoded.append('args', JSON.stringify(data))
      urlencoded.append('ticket', '')

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      }
      this.getData().disabled = true
      fetch('https://my.it-enterprise.com/WSSM/ws/webservice.asmx/ExecuteEx', requestOptions)
        .then(response => response.text())
        .then(result => {
          this.$store.commit('SET_PROCESSING', false)
          this.getData().disabled = false

          var m1 = '<string xmlns="http://tempuri.org/">', m2 = '</string>',
            i1 = result.indexOf(m1), i2 = result.indexOf(m2)
          if (i1 < 0) {
            this.$store.commit('SET_ERROR', { text: 'Під час оплати виникла помилка. Спробуйте повторити пізніше' })
            return
          }
          result = result.substring(i1 + m1.length, i2)
          result = JSON.parse(result)
          if (result.REDIRECTURL) {

            var parser = new DOMParser
            var dom = parser.parseFromString(
              '<!doctype html><body>' + result.REDIRECTURL,
              'text/html')
            var url = dom.body.textContent
            window.open(url)
          }

        })
        .catch(error => {
          this.getData().disabled = false

          this.$store.commit('SET_PROCESSING', false)
          this.$store.commit('SET_ERROR', { text: 'Під час оплати виникла помилка. Спробуйте повторити пізніше' })
          console.log('error', error)
        })
    }
  }
  getData() {
    return this.$store.state[this.getStoreModuleName()].data
  }

  /** Перечитка данных и обновление данных в store  */
  refresh() {
    this.$store.commit('SET_PROCESSING', true)
    GraphqQlApi.callOperation({operationId: 'payments'}).then(response => {
      this.$store.commit('SET_PROCESSING', false)
      var payments = response.data.energyAccountQuery.payments
      this.$store.commit(`${this.getStoreModuleName()}/setData`, {
        disabled: false,
        columns: payments.columns,
        rows: payments.data
      })
    })
  }

  /** Формирование имени для vuex модуля  */
  getStoreModuleName() {
    return `datasource_${this._id}`
  }
}